const DATE_TYPE = {
  birthday: "birthday",
  anniversary: "anniversary",
  holiday: "holiday",
};

Object.freeze(DATE_TYPE);

export { DATE_TYPE };
